var exports = {
  "p$": "slideIndicator-TWlOO",
  "kb": "left-TWlOO",
  "yo": "hovered-TWlOO",
  "OU": "captionWrapper-TWlOO",
  "pG": "caption-TWlOO",
  "BJ": "subslides-TWlOO",
  "q3": "indicator-TWlOO",
  "Om": "dot-TWlOO",
  "vu": "active-TWlOO",
};

module.exports = exports;
